import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
/* Trazabis DS: Montserrat para titulos y cifras, Inter para todo lo demas.
   Autoalojadas (@fontsource): sin dependencia de Google en build ni en uso. */
import '@fontsource/inter/latin-400.css'
import '@fontsource/inter/latin-500.css'
import '@fontsource/inter/latin-600.css'
import '@fontsource/inter/latin-700.css'
import '@fontsource/montserrat/latin-600.css'
import '@fontsource/montserrat/latin-700.css'
import './index.css'
import { App } from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
